import axios from "axios";

export interface IExchangeRateSnapshot {
  usdBuy: number;
  eurBuy: number;
  gbpBuy: number;
  date: string;
  time: string;
}

interface IRatesResponse {
  usdb: string;
  eurb: string;
  gbpb: string;
  date: string;
  time: string;
}

export const getExchangeRates = () =>
  axios.get<IRatesResponse>("https://expressdoviz.com/rates.php").then((res) => ({
    usdBuy: parseFloat(res.data.usdb),
    eurBuy: parseFloat(res.data.eurb),
    gbpBuy: parseFloat(res.data.gbpb),
    date: res.data.date,
    time: res.data.time,
  } as IExchangeRateSnapshot));

/** Bir para birimi metnini (sembol veya isim) TL'ye çeviren kur katsayısına eşler. TL ise 1, tanınmayan bir birimse null döner. */
export function resolveTryRate(currencyDisplayText: string, currencyName: string, rates: IExchangeRateSnapshot): number | null {
  const text = `${currencyDisplayText} ${currencyName}`.toLocaleLowerCase("tr");
  if (text.includes("₺") || text.includes("try") || text.includes("tl") || text.includes("lira")) return 1;
  if (text.includes("$") || text.includes("usd") || text.includes("dolar")) return rates.usdBuy;
  if (text.includes("€") || text.includes("eur")) return rates.eurBuy;
  if (text.includes("£") || text.includes("gbp") || text.includes("sterlin")) return rates.gbpBuy;
  return null;
}
